// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Colours to be used */
/* Everything related to the Internationalization view */
/* Everything related to the Installation view */
/* Everything related to the navbar */
/* Everything related to alarm page list */
/* Everything related to alarm logs page */
/* Everything related to PWR table */
/*  */
.ColorChanger_color-wrapper__aLUyK {
  display: flex;
  height: 100%;
  min-height: 1.7rem;
}
@media (max-width: 370px) {
  .ColorChanger_color-wrapper__aLUyK {
    flex-direction: row;
  }
}
.ColorChanger_color-wrapper__aLUyK .ColorChanger_data-color-container__LBMwy {
  display: flex;
  align-items: center;
  border-radius: 4px;
  overflow: hidden;
  min-width: 7.5rem;
}
@media (max-width: 370px) {
  .ColorChanger_color-wrapper__aLUyK .ColorChanger_data-color-container__LBMwy {
    flex-direction: row;
  }
}
.ColorChanger_color-wrapper__aLUyK .ColorChanger_data-color-container__LBMwy .ColorChanger_latest-data-style__aZ63a {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 80%;
  color: black;
  background-color: white;
  width: 100%;
  height: 100%;
}
.ColorChanger_color-wrapper__aLUyK .ColorChanger_data-color-container__LBMwy .ColorChanger_color-picker-button-style__-\\+pSX {
  margin-left: auto;
  cursor: "pointer";
  min-width: 24px;
  height: 100%;
}
.ColorChanger_color-wrapper__aLUyK .ColorChanger_popover__k8y0D {
  position: absolute;
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./src/utils/_utils.scss","webpack://./src/components/NodeInfo/ColorChanger.module.scss"],"names":[],"mappings":"AAAA,uBAAA;AAEA,wDAAA;AAGA,gDAAA;AAMA,qCAAA;AASA,0CAAA;AAKA,0CAAA;AAGA,oCAAA;AAMA,KAAA;AC5BA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;AAGF;AD8CE;ECpDF;IAKI,mBAAA;EAKF;AACF;AAHE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAKJ;ADkCE;EC5CA;IAQI,mBAAA;EAMJ;AACF;AAJI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,cAAA;EACA,YAAA;EAEA,uBAAA;EAEA,WAAA;EACA,YAjCS;AAoCf;AAAI;EACE,iBAAA;EACA,iBAAA;EAEA,eAAA;EACA,YAzCS;AA0Cf;AAGE;EACE,kBAAA;EACA,UAAA;AADJ","sourcesContent":[null,"/* Colours to be used */\n/* Everything related to the Internationalization view */\n/* Everything related to the Installation view */\n/* Everything related to the navbar */\n/* Everything related to alarm page list */\n/* Everything related to alarm logs page */\n/* Everything related to PWR table */\n/*  */\n.color-wrapper {\n  display: flex;\n  height: 100%;\n  min-height: 1.7rem;\n}\n@media (max-width: 370px) {\n  .color-wrapper {\n    flex-direction: row;\n  }\n}\n.color-wrapper .data-color-container {\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  overflow: hidden;\n  min-width: 7.5rem;\n}\n@media (max-width: 370px) {\n  .color-wrapper .data-color-container {\n    flex-direction: row;\n  }\n}\n.color-wrapper .data-color-container .latest-data-style {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 80%;\n  color: black;\n  background-color: white;\n  width: 100%;\n  height: 100%;\n}\n.color-wrapper .data-color-container .color-picker-button-style {\n  margin-left: auto;\n  cursor: \"pointer\";\n  min-width: 24px;\n  height: 100%;\n}\n.color-wrapper .popover {\n  position: absolute;\n  z-index: 2;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-wrapper": `ColorChanger_color-wrapper__aLUyK`,
	"data-color-container": `ColorChanger_data-color-container__LBMwy`,
	"latest-data-style": `ColorChanger_latest-data-style__aZ63a`,
	"color-picker-button-style": `ColorChanger_color-picker-button-style__-+pSX`,
	"popover": `ColorChanger_popover__k8y0D`
};
export default ___CSS_LOADER_EXPORT___;
